/**
 * Shared framer-motion variants for the editorial landing.
 * Editorial finance uses sharper ease-out (snap into place) instead
 * of the spring bounce family Lyrari uses. All eases are `as const`
 * to satisfy framer-motion v12's strict tuple type.
 */
import type { Variants } from 'framer-motion';

const easeEditorial = [0.2, 0.6, 0.2, 1] as const;

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: easeEditorial } },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5, ease: easeEditorial } },
};

export const drawLine: Variants = {
  hidden: { scaleX: 0, opacity: 0 },
  visible: {
    scaleX: 1,
    opacity: 1,
    transition: { duration: 0.7, ease: easeEditorial },
  },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06 } },
};

export const staggerSlow: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

export const sectionViewport = { once: true, margin: '-80px' as const };
